document.addEventListener("DOMContentLoaded", function () {
  const MIN_DELIVERY_DAYS = 3;
  const MAX_DELIVERY_DAYS = 5;

  if (!Date.prototype.addDaysGetDate) {
    Date.prototype.addDaysGetDate = function (days) {
      let date = new Date(this.valueOf());
      date.setDate(date.getDate() + parseInt(days));
      const month = date.toLocaleString("default", { month: "short" });
      const day = date.getDate();
      return `${month} ${day}`;
    };
  }

  function showDeliveryEstimate() {
    const minDeliveryDate = new Date().addDaysGetDate(MIN_DELIVERY_DAYS);
    const maxDeliveryDate =  new Date().addDaysGetDate(MAX_DELIVERY_DAYS);
    const dateMin = document.getElementById("fromDate");
    const dateMax = document.getElementById("toDate");
    const container = document.getElementById("deliver_estimate");

    if (dateMin && dateMax && container) {
      dateMin.textContent = minDeliveryDate;
      dateMax.textContent = maxDeliveryDate;
      container.style.display = "block";
    }
  }

  showDeliveryEstimate();
  document.addEventListener("shopify:section:load", showDeliveryEstimate);
});
